import { Spinner } from "@blueprintjs/core";
import * as React from "react";
import { useParams } from "react-router";

import { DogOwnershipChangeRequestApi, DogOwnershipChangeRequestDto, EPlatform, ERequestState } from "../../../../api";
import { PageContainer } from "../../../../components";
import { useApiService, useCrudApi, useTl } from "../../../../hooks";
import { ETLCodes } from "../../../../locales";
import { DrupalRequestResume } from "../../../common";
import { DrupalFieldSet } from "../../../common/DurpalFieldSet";
import { EDrupalRoutes } from "../../../EDrupalRoutes";
import { DrupalRshForm } from "./DrupalRshForm";

export interface IDrupalRshRequestPageProps {}

export const DrupalRshRequestPage: React.FunctionComponent<IDrupalRshRequestPageProps> = () => {
  const { id } = useParams<{ id: string }>();
  const dogOwnershipChangeRequestId = React.useMemo(() => +id, [id]);

  const { t } = useTl();
  const api = useApiService(DogOwnershipChangeRequestApi);

  // TODO-CRR : saving is used, but not saveItem???
  const { data, loading, saving } = useCrudApi<DogOwnershipChangeRequestDto>(
    React.useMemo(
      () => ({
        getApiFn: (apiId = dogOwnershipChangeRequestId) =>
          apiId > 0
            ? api.getDogOwnershipChangeRequest(apiId)
            : new DogOwnershipChangeRequestDto({
                dogOwnershipChangeRequestId: dogOwnershipChangeRequestId,
              }).toJSON(),
        saveApiFn: (d: DogOwnershipChangeRequestDto) =>
          api.save(
            DogOwnershipChangeRequestDto.fromJS({
              ...d,
              platform: EPlatform.PORTAL,
            })
          ),
        onSavedRoute: (d) =>
          d.request.status === ERequestState.BILLED
            ? `${EDrupalRoutes.rshRequest}/${d.dogOwnershipChangeRequestId}`
            : EDrupalRoutes.requestList,
        deleteApiFn: () => {},
      }),
      [api, dogOwnershipChangeRequestId]
    ),
    [dogOwnershipChangeRequestId]
  );

  return loading ? (
    <Spinner />
  ) : (
    <PageContainer>
      <DrupalFieldSet title={`${t(ETLCodes.Payment)}: ${t(ETLCodes.DogOwnershipChangeRequests)}`}>
        <div>
          <DrupalRequestResume
            requestForm={
              <DrupalRshForm
                dogOwnershipChangeRequestId={dogOwnershipChangeRequestId}
                initialdata={data}
                loading={saving}
              />
            }
            requestDto={data?.request}
            bill={null}
          />
        </div>
      </DrupalFieldSet>
    </PageContainer>
  );
};
